module.exports = __webpack_public_path__ + "static/assets/55c91836a022ad9c8bc36df8d31c0061.gif";